<template>
  <div class="shrink-container" :class="[isCollapse ? 'unfold': 'shrink', placement]" :style="style">
    <div
      class="shrink-content"
      ref="content"
    >
      <div class="content">
        <slot name='default'>
          <div></div>
        </slot>
      </div>
    </div>
    <div class="btn-container" :class="placement" @click="handelClick">
      <i :class="collapse ? 'el-icon-caret-left': 'el-icon-caret-right'"/>
    </div>
  </div>
</template>

<script>

export default {
  components: {
  },
  props: {
    defaultWidth: {
      type: Number,
      default: 304
    },
    placement: {
      type: String,
      default: 'left'
    }
  },
  data () {
    return {
      collapse: true,
      contentWidth: 304,
      contentRight: 6,
      contentLeft: 20
    }
  },
  computed: {
    style () {
      return {
        '--width': this.contentWidth + 'px',
        '--content-right': this.contentRight + 'px',
        '--content-left': this.contentLeft + 'px'
      }
    },
    isCollapse () {
      if (this.placement === 'right') {
        return !this.collapse
      }
      return this.collapse
    }
  },
  created () {
    this.contentWidth = this.defaultWidth || 304
    if (this.placement === 'right') {
      this.contentRight = 0
    } else {
      this.contentLeft = 0
    }
  },
  beforeDestroy () {

  },
  methods: {
    handelClick () {
      this.collapse = !this.collapse
      if (this.isCollapse) {
        this.$emit('open')
        this.placement === 'right' ? this.contentLeft = 6 : this.contentRight = 6
      } else {
        this.$emit('close')
        this.placement === 'right' ? this.contentLeft = 20 : this.contentRight = 20
      }
      this.$emit('change')
    }
  },
  mounted () {
    this.$nextTick(() => {
      const contentWidth = this.$refs.content.children[0].offsetWidth
      this.contentWidth = contentWidth + 12
    })
  }
}
</script>

<style lang="scss" scoped>
.shrink-container {
  &.shrink {
    width: 20px;
    height: 100%;
  }

  border-radius: 3px;
  position: relative;
  background: #FFFFFF;
  box-sizing: border-box;
  width: var(--width);
  transition: width 0.5s ease-in-out;

  &.left {
    .shrink-content {
      right: var(--content-right);
    }
  }

  &.right {
    .shrink-content {
      left: var(--content-left);
    }
  }

  .shrink-content {
    padding: 6px 0;
    position: absolute;
    height: 100%;

    .content {
      border-radius: 6px;
      background: #F7F8FA;
      height: 100%;
    }
  }

  .btn-container {
    position: absolute;
    background: #FFFFFF;
    top: 40px;
    height: 38px;
    width: 15px;
    border-radius: 3px;
    display: flex;
    align-items: center;
    cursor: pointer;

    &.left {
      right: -10px;
    }

    &.right {
      left: -10px;
    }
  }
}
</style>
